<template>
  <div class="contact-us full-screen">
    <div class="wrapper wrapper-full-page section content">
      <div class="">
        <div class="container">
          <div class="text-center">
            <h2 class="title text-danger">404 Not Found</h2>
            <h2 class="title">
              A página que você está procurando não existe...
            </h2>
            <h3 class="title">
              Volte para a página
              <router-link :to="{ path: '/' }">inicial</router-link>
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
